/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


import { Injectable } from '@angular/core';
import { StateProvider } from '../providers';
import { RestResponse, State } from '../model';
import { BehaviorSubject, Observable } from 'rxjs';
import { SearchableProvider } from '../model/interface/searchable.provider';
import { LogService } from 'src/app/services';

@Injectable()
export class StateService implements SearchableProvider {
  states = new BehaviorSubject<State[]>([]);
  states$ = this.states.asObservable();

  constructor(
    private stateProvider: StateProvider,
    private logService : LogService
  ) {
    stateProvider.getStates()
      .subscribe(data => {
        if (data.success) {
          this.states.next(State.parseArray(data.result));
        } else this.logService.error(data);
      }, error => {
        this.logService.error(error);
      });
  }

  getStateById(id: string): State {
    if (this.states.getValue())
      return this.states.getValue().filter(stage => stage.ID === id)[0];
    else return null;
  }

  getSearchType(): string {
    return 'STATE';
  }

  save(id: string, field: string, value: any): Observable<RestResponse> {
    return undefined;
  }

  search(query?: string, id?: string): Observable<any> {
    return this.states.asObservable();
  }
}
